import { useQuery } from '@tanstack/react-query';

import * as Api from 'contracts/api';
import { RequestAgent } from 'modules/request-agent';
import { useNotify } from 'pages/components/SnackBarProvider';
import { UseExposedQueryOptions } from 'queries/types';
import { throwResponseError } from 'queries/utils';
import isOkResponse from 'utils/is-ok-response';

export function useVulnerabilitiesAggregation<TData = Api.V3.Search.Aggregation.Response>(
    payload: Api.V3.Search.Aggregation.Payload,
    options?: UseExposedQueryOptions<Api.V3.Search.Aggregation.Response, Error, TData>
) {
    const notify = useNotify();
    return useQuery<Api.V3.Search.Aggregation.Response, Error, TData>({
        ...options,
        queryKey: Api.V3.Search.Aggregation.QueryKey(payload),
        queryFn: async () => {
            try {
                const response = await new RequestAgent().public.get(Api.V3.Search.Aggregation.Endpoint(), {
                    search: payload
                });

                if (isOkResponse(response)) {
                    return response.data;
                } else {
                    throwResponseError(response);
                }
            } catch (error) {
                notify.openNotification({ level: 'error', message: error.message });
                throw error;
            }
        }
    });
}
